import { MarkerF, PolygonF, PolylineF } from "@react-google-maps/api";
import { LatLng } from "./types";
import { BASE_POLYGON_OPTIONS, FENCE_STYLES } from "./PolygonContainer";

type DraftPolygonProps = {
  points: LatLng[];
  /** Fired when the user clicks the first corner to close the shape. */
  onClose: () => void;
};

const STROKE = FENCE_STYLES.NEW.strokeColor as string;

const vertexIcon = (isFirst: boolean): google.maps.Symbol => ({
  path: google.maps.SymbolPath.CIRCLE,
  scale: isFirst ? 8 : 5,
  fillColor: isFirst ? "#ffffff" : STROKE,
  fillOpacity: 1,
  strokeColor: STROKE,
  strokeWeight: 2,
});

/**
 * Live preview of a fence being drawn: the corners placed so far, the line
 * joining them, and a translucent fill once there are enough to make a shape.
 * Google removed DrawingManager from the Maps API in 3.65, so this is ours.
 */
const DraftPolygon = ({ points, onClose }: DraftPolygonProps) => (
  <>
    {points.length >= 3 && (
      <PolygonF
        path={points}
        options={{
          ...BASE_POLYGON_OPTIONS,
          ...FENCE_STYLES.NEW,
          fillOpacity: 0.25,
          clickable: false,
        }}
      />
    )}
    {points.length >= 2 && (
      <PolylineF
        path={points}
        options={{ strokeColor: STROKE, strokeOpacity: 0.9, strokeWeight: 2, clickable: false }}
      />
    )}
    {points.map((point, i) => (
      <MarkerF
        key={`${point.lat},${point.lng},${i}`}
        position={point}
        icon={vertexIcon(i === 0)}
        clickable={i === 0}
        title={i === 0 ? "Click to finish the fence" : undefined}
        onClick={i === 0 ? onClose : undefined}
        zIndex={i === 0 ? 2 : 1}
      />
    ))}
  </>
);

export default DraftPolygon;
